import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © Kenya Electricity Generating Company</Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                Design & Developed by Flag Forty Two Limited 2026 V6.0.0
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
